// Created by hejikun on 2017/11/2 0002.
let chronicDisease = [
  {
    path: '/chronicDiseaseIndex',
    name: '医生主页',
    component: () => import('@/pages/chronicDisease/chronicDiseaseIndex')
  },
  {
    path: '/chronicDiseasedep',
    name: '慢病管理',
    component: () => import('@/pages/chronicDisease/chronicDiseasedep')
  },
  {
    path: '/chronicDiseaseCard',
    name: '健康卡购买',
    component: () => import('@/pages/chronicDisease/chronicDiseaseCard')
  },
  {
    path: '/chronicDiseaseCardList',
    name: '我的卡包',
    component: () => import('@/pages/chronicDisease/chronicDiseaseCardList')
  },
  {
    path: '/chronicDiseaseCardDetail',
    name: '卡片详情',
    component: () => import('@/pages/chronicDisease/chronicDiseaseCardDetail')
  },
  {
    path: '/chronicDocList',
    name: '医生列表',
    component: () => import('@/pages/chronicDisease/chronicDocList')
  },
  {
    path: '/chronicDiseaseCardMain',
    name: '卡片详情',
    component: () => import('@/pages/chronicDisease/chronicDiseaseCardMain')
  },
  {
    path: '/chronicDiseasePackageList',
    name: '套餐列表',
    component: () => import('@/pages/chronicDisease/chronicDiseasePackageList')
  },
  {
    path: '/chronicDiseasePackageDetail',
    name: '套餐详情',
    component: () => import('@/pages/chronicDisease/chronicDiseasePackageDetail')
  },
  {
    path: '/chronicDiseaseCreateCard',
    name: '健康卡详情',
    component: () => import('@/pages/chronicDisease/chronicDiseaseCreateCard')
  },
  {
    path: '/chronicDiseaseDoctorIndex',
    name: '慢病管理',
    component: () => import('@/pages/chronicDisease/chronicDiseaseDoctorIndex')
  },
  {
    path: '/chronicDiseaseDoctorList',
    name: '医生列表',
    component: () => import('@/pages/chronicDisease/chronicDiseaseDoctorList')
  },
  {
    path: '/chronicDiseaseobj',
    name: '项目列表',
    component: () => import('@/pages/chronicDisease/chronicDiseaseobj')
  },
  {
    path: '/chronicDiseaseRegister',
    name: '绿色挂号',
    component: () => import('@/pages/chronicDisease/chronicDiseaseRegister')
  },
  {
    path: '/chronicDiseaseOrderList',
    name: '慢病订单',
    component: () => import('@/pages/chronicDisease/chronicDiseaseOrderList')
  },
  {
    path: '/chronicDisease_choose_hospital',
    name: '选择医院',
    component: () => import('@/pages/chronicDisease/chronicDisease_choose_hospital')
  },
  {
    path: '/chronicDiseaseOrderDetail',
    name: '订单详情',
    component: () => import('@/pages/chronicDisease/chronicDiseaseOrderDetail')
  }
]

export default chronicDisease
